<template>
    <div class="content ht-100v pd-0">
        <div class="content-body pd-10">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <li class="breadcrumb-item">
                                <router-link to="#">Employees</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">All Employees</li>
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">View All Employees</h4>
                    <p class="tx-color-03 tx-12 mg-b-0">{{auth.userInfo.firstName}} {{auth.userInfo.lastName}}</p>
<!--                    <p class="tx-color-03 tx-12 mg-b-0"><strong>Last login:</strong> {{auth.userInfo.userLastLoginDate | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</p>-->
                </div>
                <div class="d-none d-md-block">
                    <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"  v-b-modal="'employee-modal'"><plus-icon class="wd-10 mg-r-5" /> Add Employee</button>
                    <button class="btn btn-sm pd-x-15 btn-success btn-uppercase mg-l-5"  @click="showUploadModal"><plus-icon class="wd-10 mg-r-5" /> Upload Employees</button>
                    <download-excel
                            :data="employees"
                            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadExcel')}}
                    </download-excel>
                    <download-excel
                            type="csv"
                            :data="employees"
                            class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadCsv')}}
                    </download-excel>

                </div>
            </div>
            <base-top-cards :carditems="cards"/>
            <hr>

            <base-table
                    :items="employees"
                    :fields="fields"
                    :show-title="true"
                    :is-busy="employee.employeeLoading"
                    class="mt-2"
                    filter-mode="balances"
            ></base-table>
        </div>
        <b-modal id="employee-modal" :hide-header="true" :hide-footer="true" :centered="true" ref="employee-modal">
            <div class="modal-body">
                <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"
                   @click="hide()">
                    <span aria-hidden="true">&times;</span>
                </a>

                <div>
                    <h4>Add new employee</h4>
                    <b-form @submit.prevent="createEmployee" enctype="multipart/form-data">
                        <b-form-group label="Staff Id">
                            <b-input-group>
                                <b-input required placeholder="Staff Id" v-model="model.employeeStaffId"/>
                                <b-input required placeholder="BVN" v-model="model.employeeBvn"/>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="Name">
                            <b-input-group>
                                <b-input type="text" placeholder="First Name" required v-model="model.employeeFirstName"/>
                                <b-input type="text" placeholder="Middle Name" required v-model="model.employeeMiddleName"/>
                                <b-input type="text" placeholder="Last Name" required v-model="model.employeeLastName"/>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="Contact">
                            <b-input-group>
                                <vue-country-code @onSelect="onSelect" :preferredCountries="['vn', 'us', 'gb']">
                                </vue-country-code>
                                <b-input type="number" placeholder="Phone" required v-model="model.employeePhoneNumber"/>
                                <b-input type="email" placeholder="Email" required v-model="model.employeeEmail"/>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="ID Card">
                            <b-input-group>
                                <b-select v-model="model.employeeIdType">
                                    <b-select-option value="">Select ID Type</b-select-option>
                                    <b-select-option value="NATIONAL ID">NATIONAL ID</b-select-option>
                                    <b-select-option value="INTERNATIONAL PASSPORT">INTERNATIONAL PASSPORT</b-select-option>
                                    <b-select-option value="VOTERS CARD">VOTERS CARD</b-select-option>
                                    <b-select-option value="DRIVER LICENCE">DRIVER LICENCE</b-select-option>
                                    <b-select-option value="OHTERS">OTHERS</b-select-option>
                                </b-select>
                                <b-input type="text" placeholder="ID NUMBER" required v-model="model.employeeIdNumber"/>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="ID issue date">
                            <b-input type="date" placeholder="ISSUE DATE" required v-model="model.employeeIdIssueDate"/>
                        </b-form-group>
                        <b-form-group label="Date of birth">
                            <b-input-group>
                                <b-input type="date" placeholder="Date of birth" required v-model="model.employeeDob"/>
                                <b-select v-model="model.employeeGender">
                                    <b-select-option value="">Select Gender</b-select-option>
                                    <b-select-option value="MALE">MALE</b-select-option>
                                    <b-select-option value="FEMALE">FEMALE</b-select-option>
                                </b-select>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="Nationality">
                            <country-select id="orgCountry" class="form-control" :countryName="true" :regionName="true" v-model="model.employeeNationality" :country="model.employeeNationality" topCountry="NG" />
                        </b-form-group>
                        <b-form-group label="Employment Details">
                            <b-input-group>
                                <b-select v-model="model.employeeDepartment">
                                    <b-select-option value="">Select Department</b-select-option>
                                    <b-select-option v-for="dpt in department.departments" :value="dpt.employerDepartmentCode" v-bind:key="dpt.employerDepartmentCode">{{dpt.employerDepartmentName}}</b-select-option>
                                </b-select>
                                <b-select v-model="model.employeeGradeCode">
                                    <b-select-option value="">Select Grade</b-select-option>
                                    <b-select-option v-for="grd in grade.grades" :value="grd.employerGradeCode" v-bind:key="grd.employerGradeCode">{{grd.employerGradeName}}</b-select-option>
                                </b-select>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label="Employee Role">
                            <b-input type="text" placeholder="Role" required v-model="model.employeeRole"/>
                        </b-form-group>
                        <base-button title="Submit" :loading="employee.employeeLoading"/>
                    </b-form>
                </div>
            </div><!-- modal-body -->
        </b-modal>
        <upload-csv-modal
                :show="showModal"
                :header="myHeaders"
                :is-loading="employee.employeeLoading"
                read-type="employee/updateEmployees"
                upload-type="employee/createEmployee"
                :read-data="readData"
                :upload-data="uploadModel"
        />
    </div>
</template>

<script>
    import BaseTopCards from "../../components/card/BaseTopCards";
    import BaseTable from "../../components/table/BaseTable";
    import BaseButton from "../../components/button/BaseButton";
    import { PrinterIcon, PlusIcon } from 'vue-feather-icons'
    import UploadCsvModal from "../../components/modal/UploadCsvModal";
    import {mapState} from 'vuex'

    export default {
        name: 'Loan',
        data() {
            return {
                showModal:true,
                model:{
                    employeeStaffId: '',
                    employeeBvn: '',
                    employeeDob: '',
                    employeeEmail: '',
                    employeeFirstName: '',
                    employeeMiddleName: '',
                    employeeLastName: '',
                    employeeGender: '',
                    employeeIdType: '',
                    employeeIdNumber: '',
                    employeeIdIssueDate: '',
                    employeeNationality: '',
                    employeePhoneNumber: '',
                    employeeCountryCode: '',
                    employeeDepartment: '',
                    employeeGradeCode: '',
                    employeeManagerId: '',
                    employerId: '',
                    employeeRole: '',
                    requestType: '',
                    employeeMaker: ''
                },
                uploadModel:{
                    requestType: '',
                    employeeMaker: '',
                    employerId: '',
                    data: []
                },
                file: {
                    accountnumber: '',
                    file: '',
                    amount: '',
                    status: false,
                    bank: {},
                    narration: '',
                    uploadedFiles: [],
                    uploadError: null,
                    currentStatus: null,
                    uploadFieldName: 'photos',
                },
                fields: [
                    // { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
                    { key: 'employeeDetailStaffId', label: 'Staff Id', sortable: true, sortDirection: 'desc' },
                    { key: 'employeeIdNumber', label: 'Employee Id', sortable: true, class: 'text-left' },
                    { key: 'employeeFirstName', label: 'First Name', sortable: true, class: 'text-left' },
                    { key: 'employeeLastName', label: 'Last Name', sortable: true, class: 'text-left' },
                    { key: 'employeePhoneNumber', label: 'Phone', sortable: true, class: 'text-left' },
                    { key: 'employeeDetailGradeCode', label: 'Department', sortable: true, class: 'text-left' },
                    { key: 'employeeDetailRole', label: 'Role', sortable: true, class: 'text-left' },
                    { key: 'employeeDetailDate', label: 'Date of Reg.', sortable: true, sortDirection: 'desc', class: 'text-left' },
                    { key: 'employeeDetailStatus', label: 'Status', sortable: true, class: 'text-left' },
                    { key: 'actions', label: 'Action', sortable: true, class: 'text-center' }
                ],
                myHeaders:[
                    'employeeStaffId', 'employeeBvn', 'employeeDob', 'employeeEmail', 'employeeFirstName',  'employeeMiddleName',
                    'employeeLastName', 'employeeGender', 'employeeIdType', 'employeeIdNumber', 'employeeIdIssueDate',
                    'employeeNationality','employeePhoneNumber', 'employeeCountryCode', 'employeeDepartment', 'employeeGradeCode',
                    'employeeRole\r'
                ],
                readData:{
                    readAll:'NO',
                    employerId: ''
                }
            }
        },
        components: {
            BaseButton,
            BaseTable,
            BaseTopCards,
            PrinterIcon,
            UploadCsvModal,
            PlusIcon,
        },
        computed: {
            cards:{
                get(){
                    return [
                        {
                            id: 0,
                            name: 'Total Employees',
                            number: this.employees.length,// == null?'0.00':'GHS '+this.numberWithCommas(this.totalGhs),
                            color: 'bg-primary'
                        },
                        {
                            id: 1,
                            name: 'Active Employees',
                            number: this.employees.filter(it => it.employeeDetailStatus.toUpperCase() === 'ACTIVE').length,// == null?'0.00':'GBP '+this.numberWithCommas(this.totalGbp),
                            color: 'bg-orange'
                        },
                        {
                            id: 2,
                            name: 'Pending Employees',
                            number: this.employees.filter(it => it.employeeDetailStatus.toUpperCase() === 'PENDING').length,// == null?'0.00':'USD '+this.numberWithCommas(this.totalUsd),
                            color: 'bg-success'
                        },
                        {
                            id: 3,
                            name: 'Suspended Employees',
                            number: this.employees.filter(it => it.employeeDetailStatus.toUpperCase() === 'SUSPENDED').length,// == null?'0.00':'EUR '+this.numberWithCommas(this.totalEur),
                            color: 'bg-black-8'
                        }
                    ]
                },
                set(){

                }
            },
            grades(){
                return  this.grade.grades
            },
            employees(){
                return  this.employee.employees?this.employee.employees:[]
            },
            authobj: function () {
                return this.$store.state.auth.response
            },
            ...mapState([
                'employee',
                'department',
                'grade',
                'auth'
            ])
        },
        methods: {
            showUploadModal(){
                this.readData.employerId = localStorage.orgID
                this.uploadModel.requestType = 'bulkUpload'
                this.uploadModel.employeeMaker = `${this.auth.userInfo.firstName} ${this.auth.userInfo.lastName}`
                this.uploadModel.employerId = localStorage.orgID
                this.showModal = !this.showModal
            },

            async createEmployee(){
                this.model.employeeMaker = `${this.auth.userInfo.firstName} ${this.auth.userInfo.lastName}`;
                this.model.employerDepartmentEmployerId = localStorage.orgID;
                this.model.employerId = localStorage.orgID;
                this.model.requestType = 'create'
                await this.$store.dispatch("employee/createEmployee", this.model, {root: false});
                this.loadEmployee();
                this.hide();
                let self = this;
                // eslint-disable-next-line no-unused-vars
                Object.keys(this.model).forEach(function(key,index) {
                    self.model[key] = '';
                });
            },

            loadEmployee(){
                this.$store.dispatch("employee/updateEmployees", {
                    readAll:'NO',
                    employerId: localStorage.orgID
                }, {root: false}).then()
            },
            loadGrade(){
                this.$store.dispatch("grade/updateGrades", {
                    readAll:'NO',
                    employerId: localStorage.orgID
                }, {root: false}).then()
            },
            loadDepartment(){
                this.$store.dispatch("department/updateDepartments", {
                    readAll:'NO',
                    employerId: localStorage.orgID
                }, {root: false}).then()
            },
            hide() {
                this.$refs['employee-modal'].hide()
                this.$refs['employee-upload-modal'].hide()
            },
            onSelect({name, iso2, dialCode}) {
                this.model.employeeCountryCode =  dialCode
                console.log(name, iso2, dialCode);
            },
            numberWithCommas(x) {
                let parts = x.toString().split(".");
                if (parts[1] == null)  parts[1] = '00'
                else if (parts[1].length === 0) parts[1] = parts[1]+'00'
                else if (parts[1].length === 1) parts[1] = parts[1]+'0'
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            },
        },
        created() {
            this.$store.dispatch("employee/updateEmployees", {
                readAll:'NO',
                employerId: localStorage.orgID
            }, {root: false}).then()
            this.loadDepartment()
            this.loadGrade()
        }
    }


</script>

<style scoped>
    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: lightcyan;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>
